<template>
    <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Product</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Nama Layanan"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="Nama Layanan"
                v-model="productData.serviceName"
                @input="handleProductSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                id="product_slug"
                label="Product Url"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="Product Url"
                v-model="productData.slug"
                @input="handleProductSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                id="service_desc"
                label="Deskripsi Layanan"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="Deskripsi Layanan"
                v-model="productData.serviceDescription"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Available to</label>
                <div class="col-sm-9">
                  <multiselect
                      v-model="productData.on_delivery_supports"
                      :options="['COD','DFOD']"
                      :multiple="true"
                      placeholder="Available to"
                      :open-direction="'top'"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Country"
                  placeholder="Pilih negara"
                  :options="availableForOptions"
                  required
                  horizontal
                  class="required"
                  v-model="productData.available_for"
                  @change="handleAvailableFor"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Language"
                  placeholder="Pilih bahasa"
                  :options="languageOptions"
                  required
                  horizontal
                  v-model="productData.language"
                  :disabled="productData.available_for === 'malaysia'"
                  @change="handleLanguage"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <a>Syarat & Ketentuan</a>
              <editor
                id="editor"
                :api-key="key"
                :init="initOption"
                v-model="productData.termCondition"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                label="Asset banner"
                horizontal
                type="file"
                accept="image/png, image/jpg, image/jpeg"
                @change="handleMainAsset"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="urlMainAsset">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg1" :src="urlMainAsset"/>
            </CCol>
            <div class="wording-file-info warning-input" v-if="mainAssetError">
              Foto Main Asset tinggi tidak boleh lebih 75px dan kurang dari pada 60px atau
              panjang tidak boleh lebih daripada 125px dan kurang dari 118px
            </div>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="ALT Asset banner"
                type="text"
                horizontal
                placeholder="ALT Asset banner"
                v-model="productData.alt_main_asset"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                label="Asset preview"
                horizontal
                type="file"
                accept="image/png, image/jpg, image/jpeg"
                @change="handlePreviewAsset"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="urlPreviewAsset">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg2" :src="urlPreviewAsset"/>
            </CCol>
            <div class="wording-file-info warning-input" v-if="previewAssetError">Foto preview harus berukuran 350x125px, silahkan upload kembali</div>
          </CRow>

          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_estimation"
                  label="Product Estimation"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Product Estimation"
                  v-model="productData.text_estimation"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_estimation_color"
                  label="Product Estimation Text Color"
                  class="mb-0"
                  type="color"
                  required
                  horizontal
                  placeholder="Product Estimation Text Color"
                  v-model="productData.text_color_estimation"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="urlHorizontalAsset">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg2" :src="urlHorizontalAsset"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_estimation_Background_color"
                  label="Product Estimation Background Color"
                  class="mb-0"
                  type="color"
                  required
                  horizontal
                  placeholder="Product Estimation Background Color"
                  v-model="productData.background_color_text_estimation"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_title"
                  label="Product Title"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Product Title"
                  v-model="productData.text_service_title"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_service_tooltip"
                  label="Product Tooltip"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Product Tooltip"
                  v-model="productData.text_tooltip"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_service_description"
                  label="Product Description Home"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Product Description Home"
                  v-model="productData.text_service_description"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                  label="Asset Home Product"
                  horizontal
                  type="file"
                  accept="image/png, image/jpg, image/jpeg, image/svg+xml"
                  @change="handleAssetHomeProduct"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="urlServiceAsset">
            <CCol :col="8">
              <img class="image-ilustrasi" :src="urlServiceAsset"/>
              <div class="warning-input" style="padding-left: 11rem" v-if="serviceAssetError">Foto Service Asset file terlalu besar </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="ALT Asset Home Product"
                type="text"
                horizontal
                placeholder="ALT Asset Home Product"
                v-model="productData.alt_root_service_asset"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Status Ribbon"
                  :options="optionShowRibbon"
                  required
                  horizontal
                  v-model="productData.show_ribbon"
                  @change="handleShowRibbon"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="text_ribbon"
                  label="Ribbon Title"
                  class="mb-0"
                  type="text"
                  horizontal
                  placeholder="Ribbon Title of Product"
                  v-model="productData.text_ribbon"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Ribbon Title Color"
                  class="mb-0"
                  type="color"
                  required
                  horizontal
                  placeholder="Ribbon Text color"
                  v-model="productData.text_color_ribbon"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Ribbon Background Color"
                  class="mb-0"
                  type="color"
                  required
                  horizontal
                  placeholder="Ribbon Background Color"
                  v-model="productData.background_color_ribbon"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                  label="Asset Icon Ribbon"
                  horizontal
                  type="file"
                  accept="image/png, image/jpg, image/jpeg, image/svg+xml"
                  @change="handleAssetIconRibbon"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="urlIconRibbonAsset">
            <CCol :col="8">
              <img class="image-ilustrasi" :src="urlIconRibbonAsset"/>
              <div class="warning-input" style="padding-left: 11rem" v-if="iconRibbonAssetError">Icon Ribbon Asset file terlalu besar</div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_promo_text_ribbon"
                  label="Promo Ribbon Title"
                  class="mb-0"
                  type="text"
                  horizontal
                  placeholder="Promo Ribbon Title"
                  v-model="productData.promo_text_ribbon"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_promo_text_ribbon_color"
                  label="Promo Ribbon Text Color"
                  class="mb-0"
                  type="color"
                  horizontal
                  v-model="productData.promo_text_color_ribbon"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_promo_bg_ribbon_color"
                  label="Promo Ribbon Background Color"
                  class="mb-0"
                  type="color"
                  horizontal
                  v-model="productData.promo_background_color_ribbon"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="product_priority"
                  type="number"
                  min="0"
                  max="1000"
                  label="Priority"
                  class="mb-0"
                  horizontal
                  placeholder="Priority to show on Website"
                  v-model="productData.priority"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                  label="Asset Horizontal"
                  horizontal
                  type="file"
                  accept="image/png, image/jpg, image/jpeg, image/svg+xml, image/webp"
                  @change="handleHorizontalLogo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="urlHorizontalAsset">
            <CCol :col="8">
              <img class="image-ilustrasi" :src="urlHorizontalAsset"/>
              <div class="warning-input" style="padding-left: 11rem" v-if="iconRibbonAssetError">Horizontal Asset file terlalu besar</div>
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Asuransi</label>
                <div class="col-sm-9 d-flex align-items-center">
                  <CInputCheckbox
                      id="is_use_insurance"
                      label="Gunakan Asuransi"
                      v-model="productData.is_use_insurance"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Klasifikasi Barang</label>
                <div class="col-sm-9">
                  <multiselect
                      v-model="productData.dangerous_goods"
                      :options="dangerousGoods"
                      :multiple="true"
                      track-by="class"
                      label="title"
                      :reduce="dg => dg.class"
                      placeholder="Pilih klasifikasi barang"
                      :open-direction="'top'"
                  />
                </div>
              </div>
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="8">
              <div class="form-group form-row">
                <label class="col-sm-3 col-form-label">Karantina</label>
                <div class="col-sm-9">
                  <BadgeInput
                      v-model="productData.karantina"
                      placeholder="Daerah 1, Daerah 2"
                      badge-color="light"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Show Section POS Interpack"
                  :options="optionShowSectionPOSInterpack"
                  required
                  horizontal
                  v-model="productData.show_pos_interpack"
                  @change="handleShowSectionPOSInterpack"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="createNewProduct">Save</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Axios from 'axios'
import Swal from 'sweetalert2'
import jwt from "jsonwebtoken";
import Editor from "@tinymce/tinymce-vue";
import initTinymce from "@/app/constants/initTinymce";
import Multiselect from "vue-multiselect";
import { dangerousGoods } from "@/app/constants/dangerous_goods"
import BadgeInput from "@/components/BadgeInput.vue";

export default {
  components: {BadgeInput, Multiselect, editor: Editor },
  props: {
    lang: {
      type: String,
      required: false,
      default: "ID"
    }
  },
   data(){
       return{
            productData:{
                serviceName:"",
                slug:"",
                serviceDescription:"",
                termCondition:"",
                mainAsset:"",
                alt_main_asset: "",
                previewAsset:"",
                status:"ACTIVE",
                text_tooltip: "",
                text_estimation: "",
                text_color_estimation: "#F35050",
                background_color_text_estimation: "#FFEEEE",
                text_service_title: "",
                text_service_description: "",
                root_service_asset: null,
                alt_root_service_asset: "",
                show_ribbon: false,
                icon_ribbon_asset: null,
                text_color_ribbon: "#FFEEEE",
                background_color_ribbon: "#F35050",
                promo_text_ribbon:"PROMO",
                promo_text_color_ribbon: "#FFFFFF",
                promo_background_color_ribbon: "#D11F40",
                text_ribbon: "",
                priority: null,
                show_pos_interpack: false,
                on_delivery_supports: "",
                horizontal_logo_asset: null,
                is_use_insurance: "false",
                dangerous_goods: [],
                karantina: [],
                available_for: 'indonesia',
                language: 'indonesia',

            },
            urlMainAsset:"",
            urlPreviewAsset:"",
            urlServiceAsset: "",
            urlIconRibbonAsset: "",
            mainAssetError:false,
            previewAssetError:false,
            serviceAssetError: false,
            iconRibbonAssetError: false,
            optionShowRibbon:[ {value: true, label: "ACTIVE"}, {value: false, label: "INACTIVE"}],
            optionShowSectionPOSInterpack:[{value: true, label: "ACTIVE"}, {value: false, label: "INACTIVE"}],
            domian: process.env.VUE_APP_DOMAIN_URL,
            token: "Bearer " + localStorage.getItem("token"),
            initOption: initTinymce.init,
            key: initTinymce.key,
            dangerousGoods,
            urlHorizontalAsset:"",
            newKarantina: "",
             availableForOptions: [
               { value: 'indonesia', label: 'Indonesia' },
               { value: 'malaysia', label: 'Malaysia' }
             ],
         languageOptions: [
           { value: 'indonesia', label: 'Indonesia' },
           { value: 'english', label: 'English' }
         ],
       }
   },
   mounted(){
     this.authentication()
   },
   methods: {
     authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({ path: `/` });
      }
    },
    handleMainAsset(event) {
      const file = event[0];
      this.urlMainAsset = URL.createObjectURL(file);
      this.productData.mainAsset = file;
      this.mainAssetError = file.size > 200000;
    },
    handlePreviewAsset(event) {
      const file = event[0];
      this.urlPreviewAsset = URL.createObjectURL(file);
      this.productData.previewAsset = file;
       this.mainAssetError = file.size > 200000;
    },
    handleAssetHomeProduct(event) {
      const file = event[0];
      this.urlServiceAsset = URL.createObjectURL(file);
      this.productData.root_service_asset = file
      this.previewAssetError = file.size > 200000;
    },
    handleAssetIconRibbon(event) {
      const file = event[0];
      this.urlIconRibbonAsset = URL.createObjectURL(file);
      this.productData.icon_ribbon_asset = file
      this.iconRibbonAssetError = file.size > 200000;
    },
    handleShowRibbon(event) {
      this.productData.show_ribbon = event.target.value;
    },
    handleShowSectionPOSInterpack(event) {
      this.productData.show_pos_interpack = event.target.value;
    },
    handleProductSlug(event){
       var slug = event.replaceAll(/[^A-Za-z0-9 -]/g,'').replaceAll(' ','-').replaceAll('--','-').toLowerCase().trim();
       this.productData.slug = slug;
    },
     handleHorizontalLogo(event) {
       const file = event;
       if (file && file.length > 0) {
         this.productData.horizontal_logo_asset = file[0];
         this.urlHorizontalAsset = URL.createObjectURL(file[0]);
       }
     },

    validateSizeImage(file, event){
        let img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
            if (event === "main_asset" && img.height !== 255 && img.width !== 720){
                this.mainAssetError = true
            }else if(event === "main_asset" && img.height === 255 && img.width === 720){
                this.mainAssetError = false
            }
            if (event === "preview_asset" && img.height !== 125 && img.width !== 350){
                this.previewAssetError = true
            }else if (event === "preview_asset" && img.height === 125 && img.width === 350){
                this.previewAssetError = false
            }
        }
    },
      validateImageSubmit(){
        var err = false
        if (this.mainAssetError){
            this.responseError("error", "Foto banners tidak valid")
            err =true
        }
        if(this.previewAssetError){
            this.responseError("error", "Foto preview tidak valid")
            err = true
        }
        if(this.serviceAssetError) {
          this.responseError("error", "Foto product tidak valid")
          err = true
        }
        if(this.iconRibbonAssetError) {
          this.responseError("error", "icon ribbon product tidak valid")
          err = true
        }
        if(this.productData.show_ribbon === "true" && this.productData.text_ribbon.trim() === "" && !this.productData.icon_ribbon_asset) {
          this.responseError("error", "ribbon title atau icon ribbon harus diisi kalau show ribbon active")
          err = true
        }
        if(!this.iconRibbonAssetError && this.productData.icon_ribbon_asset) {
          this.productData.text_ribbon = ""
        }
        return err
    },
     handleAvailableFor(event) {
       this.productData.available_for = event.target.value

       if (this.productData.available_for === 'malaysia') {
         this.productData.language = 'english'
       }
     },
     handleLanguage(event) {
       this.productData.language = event.target.value
     },
     createNewProduct(){
        var err = this.validateImageSubmit()
        if (err){
            return
        }
        var form = new FormData()
        form.append("service_name", this.productData.serviceName)
        form.append("slug", this.productData.slug)
        form.append("service_description", this.productData.serviceDescription)
        form.append("terms_conditions", this.productData.termCondition)
        form.append("main_asset", this.productData.mainAsset)
        form.append("alt_main_asset", this.productData.alt_main_asset)
        form.append("preview_asset", this.productData.previewAsset)
        form.append("status", this.productData.status)
        form.append("text_estimation", this.productData.text_estimation)
        form.append("text_color_estimation", this.productData.text_color_estimation)
        form.append("background_color_text_estimation", this.productData.background_color_text_estimation)
        form.append("text_service_title", this.productData.text_service_title)
        form.append("text_tooltip", this.productData.text_tooltip)
        form.append("text_service_description", this.productData.text_service_description)
        form.append("root_service_asset", this.productData.root_service_asset)
        form.append("alt_root_service_asset", this.productData.alt_root_service_asset)
        form.append("show_ribbon", this.productData.show_ribbon)
        form.append("icon_ribbon_asset", this.productData.icon_ribbon_asset)
        form.append("text_color_ribbon", this.productData.text_color_ribbon)
        form.append("background_color_ribbon", this.productData.background_color_ribbon)
        form.append("text_ribbon", this.productData.text_ribbon)
        form.append("promo_text_ribbon", this.productData.promo_text_ribbon)
        form.append("promo_text_color_ribbon", this.productData.promo_text_color_ribbon)
        form.append("promo_background_color_ribbon", this.productData.promo_background_color_ribbon)
        if (this.productData.priority === "" || this.productData.priority === "0" || this.productData.priority === undefined) {
          this.productData.priority = null
        }
        form.append("priority", this.productData.priority)
        form.append("show_pos_interpack", this.productData.show_pos_interpack)

       const supports = Array.isArray(this.productData.on_delivery_supports)
           ? this.productData.on_delivery_supports.map(s => s.toLowerCase()).join(',')
           : ''
       form.append('on_delivery_supports', supports)

       if (this.productData.horizontal_logo_asset) {
         form.append('horizontal_logo_asset', this.productData.horizontal_logo_asset)
       }

       form.append('is_use_insurance', this.productData.is_use_insurance ? 'true' : 'false')

       const dg = Array.isArray(this.productData.dangerous_goods)
           ? this.productData.dangerous_goods
               .map(d => d.class)
               .sort((a, b) => a - b)
               .join(',')
           : '';
       form.append("dangerous_goods", dg);

       form.append('karantina', this.productData.karantina.join(','));
       form.append('available_for', this.productData.available_for || 'indonesia')


       form.append('lang', {
         indonesia: 'ID',
         english: 'EN'
       }[this.productData.language] || 'ID')

       Axios.post(`${this.domian}/v2/product_detail/admin`, form, {
          headers: {
              Authorization: this.token,
              "Content-Type": "application/json"
          }
        })
        .then((resp)=>{
          if (resp.status === 201){
              this.responseError("success", "Data berhasil dibuat")
              this.$router.push({ path: "/management/product/list/"+ this.lang.toLowerCase() })
          }
        })
        .catch((err)=>{
          this.responseError("error", err.response.data.desc.id)
        })
     },
       responseError(status, message){
           Swal.fire({
                icon: status,
                title: message,
                showConfirmButton: false,
                timer: 2000
             });
     },
       goBack() {
        this.usersOpened
            ? this.$router.go(-1)
            : this.$router.push({ path: "/management/product/list/" + this.lang.toLowerCase() });
       },
   },
}
</script>

<style scoped>
@import "./Product.css";
</style>
